module.exports = __webpack_public_path__ + "2e238fc2298e526f753e8c7cf00ea1f7.svg";